import { Alert } from '@ksyos/design-system';
import type { HolterConfigureData } from '@common/validation/customControls/cardiology/holter/holterConfigureSchemas';
import type { HolterDirectExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterDirectExaminationRequestSchemas';
import { HardwareProcessStatus } from '@common/enums';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';

export function HolterConfigureInfoAlert() {
    const { data } = useProcessActivityEditContext<HolterDirectExaminationRequestData | HolterConfigureData>();

    const { hasDesktopProcessTimedOut, isMissingKsyosUrlHandler, processError, processStatus } = data;
    const hasErrors = hasDesktopProcessTimedOut || isMissingKsyosUrlHandler || processError;

    if (hasErrors || processStatus === HardwareProcessStatus.completed) {
        return;
    }

    return <Alert appearance="info">Sluit nu de recorder aan op de computer om deze in te stellen</Alert>;
}
